import type React from "react"
import { Box, Typography, Container, Grid, IconButton, Divider } from "@mui/material"
import { IconBrandFacebook, IconBrandInstagram, IconBrandTiktok, IconBrandWhatsapp } from "@tabler/icons-react"

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear()

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#3c2a20",
                color: "white",
                py: 4,
                mt: 5,
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={3} alignItems="center" justifyContent="center">
                    <Grid item xs={12} md={6} sx={{ textAlign: { xs: "center", md: "left" } }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontFamily: "'Montserrat', sans-serif",
                                fontWeight: 600,
                                mb: 1,
                            }}
                        >
                            E-Kochalita
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Cuadritos decorativos con resina epóxica
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ textAlign: { xs: "center", md: "right" } }}>
                        <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" }, gap: 1, mb: 2 }}>
                            <IconButton
                                href="https://www.facebook.com/ekochalita"
                                target="_blank"
                                aria-label="Facebook"
                                sx={{ color: "white", "&:hover": { color: "#3b5998" } }}
                            >
                                <IconBrandFacebook size={24} />
                            </IconButton>
                            <IconButton
                                href="https://www.instagram.com/ekochalita"
                                target="_blank"
                                aria-label="Instagram"
                                sx={{ color: "white", "&:hover": { color: "#e1306c" } }}
                            >
                                <IconBrandInstagram size={24} />
                            </IconButton>
                            <IconButton
                                href="https://www.tiktok.com/@ekochalita"
                                target="_blank"
                                aria-label="TikTok"
                                sx={{ color: "white", "&:hover": { color: "#69c9d0" } }}
                            >
                                <IconBrandTiktok size={24} />
                            </IconButton>
                            <IconButton
                                href="https://wa.me/59174318810"
                                target="_blank"
                                aria-label="WhatsApp"
                                sx={{ color: "white", "&:hover": { color: "#25D366" } }}
                            >
                                <IconBrandWhatsapp size={24} />
                            </IconButton>
                        </Box>
                        <Typography variant="body2">WhatsApp: +591 74318810</Typography>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 2, backgroundColor: "rgba(255,255,255,0.1)" }} />

                <Typography
                    variant="body2"
                    align="center"
                    sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        opacity: 0.8,
                    }}
                >
                    &copy; {currentYear} E-Kochalita - Rossmel Abasto. Todos los derechos reservados.
                </Typography>
            </Container>
        </Box>
    )
}

export default Footer

